module.exports = __webpack_public_path__ + "assets/minimum-f815f7.svg";